<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card outlined class="pa-6 text-center">
          <template v-if="loading">
            <v-progress-circular indeterminate color="primary" class="mb-4"></v-progress-circular>
            <p>Verbindung wird hergestellt ...</p>
          </template>
          <template v-else-if="success">
            <p class="text-h6">✅ Bot erfolgreich verbunden!</p>
            <p>Dein Discord-Server ist jetzt mit dem Bot verknüpft und aktiv ausgewählt.</p>
            <v-btn color="primary" @click="goToSuccessTarget">
              {{ isFromMyServers ? 'Zu Meinen Servern' : 'Weiter zu den Live-Ankündigungen' }}
            </v-btn>
          </template>
          <template v-else>
            <p class="text-h6">❌ Verbindung fehlgeschlagen</p>
            <p>{{ errorMessage }}</p>
            <v-btn color="primary" @click="goToErrorTarget">
              {{ isFromMyServers ? 'Zurück zu Meinen Servern' : 'Zurück zum Onboarding' }}
            </v-btn>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      loading: true,
      success: false,
      errorMessage: '',
    };
  },
  computed: {
    isFromMyServers() {
      return this.$route.query.state === 'my_servers';
    },
  },
  methods: {
    goToSuccessTarget() {
      if (this.isFromMyServers) {
        this.$router.push({ name: 'my_servers' });
      } else {
        this.$router.push({ name: 'onboarding', query: { step: '3' } });
      }
    },
    goToErrorTarget() {
      if (this.isFromMyServers) {
        this.$router.push({ name: 'my_servers' });
      } else {
        this.$router.push({ name: 'onboarding', query: { step: '2' } });
      }
    },
  },
  mounted() {
    const guildId = this.$route.query.guild_id;
    if (!guildId) {
      this.loading = false;
      this.success = false;
      this.errorMessage = 'Es wurde kein Server ausgewählt oder die Einladung wurde abgebrochen.';
      return;
    }
    const confirmedInstance = sessionStorage.getItem('dcInviteConfirmedInstanz') || undefined;
    sessionStorage.removeItem('dcInviteConfirmedInstanz');
    BackendService.connectDiscordBotGuild({ guildId, confirmedInstance }).then(() => {
      this.loading = false;
      this.success = true;
    }).catch((error) => {
      this.loading = false;
      this.success = false;
      if (error.response && error.response.status === 409) {
        this.errorMessage = 'Der Bot wurde nicht auf dem ausgewählten Server gefunden. Bitte stelle sicher, dass die Einladung erfolgreich war.';
      } else if (error.response && error.response.status === 403) {
        this.errorMessage = 'Für deinen Account ist aktuell keine freie Discord-Server-Lizenz verfügbar. Bitte kontaktiere den Support, um eine weitere Lizenz zu erhalten.';
      } else if (error.response && error.response.status === 428) {
        this.errorMessage = 'Bitte bestätige zuerst auf der Onboarding-Seite, für welchen Twitch-Kanal du den Bot einrichtest, bevor du ihn einlädst.';
      } else {
        this.errorMessage = 'Verbindung zum Server nicht möglich. Bitte versuche es erneut.';
      }
    });
  },
};
</script>
